import { Link } from "@tanstack/react-router";
import Raiders from "../assets/raiders.png";

const LogoRaiders = () => {
  return (
      <>
        <div className="demo-logo relative flex">
          <Link to="/" tabIndex={-1}>
            <img
                src={Raiders}
                className="min-w-[60px] w-[60px] sm:w-[80px] md:w-[120px] lg:w-[160px] duration-300"
                alt="Dune Raiders"
                title={"Dune Raiders"}
            />
          </Link>
        </div>
      </>
  );
};
export default LogoRaiders;
